import React, { useState, useEffect, useContext } from "react";
// import ClinicalAuditReviewForm from "../components/Audit/ClinicalAuditReviewForm";
import { ApiCall } from "../../utility/ApiCalls";
import Box from "@mui/system/Box";
import ClinicalReviewAuditForRebuttal from "./ClinicalReviewAuditForRebuttal";
import Api_Call from "../../ApiCall";
import menus from "../../user-config.json";
// import { UserContextForRebuttal3ColmnsProvider } from "./userContextForRebuttal3Colmns";
import UserContext from "../Common/UserContext";
function ClinicalReviewAudit() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userRole: user } = useContext(UserContext);
  console.log(user);
  async function getAuditData(e) {
    console.log("Inside getValidatedTask API call ");
    console.log(sessionStorage.getItem("ActiveTaskID"));
    const api = new Api_Call();
    const data = await api.getData(
      `AUDIT/DATA?taskID=${sessionStorage.getItem(
        "ActiveTaskID"
      )}&user_type=${user}&clinical_data=${
        menus[user.toLowerCase()]["clinical"]
      }`
    );
    // const ret = await ApiCall(
    //   {
    //     taskID: sessionStorage.getItem("ActiveTaskID"),
    //     // taskID: "110003",
    //     clinical_data: "0",
    //     user_type: user,
    //   },
    //   "vcare-ui",
    //   "vcareui_clinicalaudit"
    // );
    const repsonse = data.body;
    console.log(
      "setting state ===================================================== "
    );
    console.log(data.body);

    setData(data.body);
    setLoading(false);

    return repsonse;
  }
  useEffect(() => {
    getAuditData();
  }, []);
  if (loading) {
    return (
      <div>
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      </div>
    );
  } else {
    return (
      //  <UserContextForRebuttal3ColmnsProvider>
      <ClinicalReviewAuditForRebuttal data={data} />
    );
  }
}

export default ClinicalReviewAudit;
